<template>
  <div class="payment-content">
    <h1>真菌库的菌种鉴定</h1>
    <h4 style="font-size: 15px">(Active substance separation and purification services)</h4>
    <br/>
    <p style="font-size: 16px">
      自然界中生物体产生的天然产物已被用作药物已经有数千年。早在公元前二世纪使用青蒿植物来治疗疟疾。另外近代早期的微生物学导致了从微生物中发现了大量的药物，最著名的如亚历山大·弗莱明发现的青霉素。当前真菌仍然是治疗传染病药物的最大来源。与其他天然产物资源相比，真菌具有以下优势。首先，真菌种类繁多，已描述的真菌种类约有 120,000 种和510万种未知真菌。其次，真菌可以产生结构广泛和多样的次级代谢产物。最后大规模发酵可生产大量的真菌次生代谢产物。近年来基因组测序技术的快速发展和更多的生物合成基因簇的挖掘，加速发现了更多来自真菌的新化合物。真菌可以从土壤、水、空气、植物或其他生物体中分离出来。尤其，植物的内生真菌可以产生与其宿主相近的次级代谢产物。生物多样化的真菌库对学术研究和工业界至关重要。澳岚丁通过多年的努力建立了一个样品来自全球且具有高度生物多样性的真菌库以促进新药的发现。
    </p>
    <br/>
    <div class="trait">
      <h3>服务明细信息</h3>
      <table class="custom-table">
        <tr>
          <th>规格</th>
          <th>单价(元)</th>
          <th>供货周期</th>
        </tr>
        <tr>
          <td>板(88个)</td>
          <td>4400</td>
          <td>1-4个星期</td>
        </tr>
      </table>
      <br/>
      <p>备注：
        <br/>
        •	提供ITS序列，菌种照片，真菌的种属。 
        <br/>
        •	菌种次生代谢产物与真菌培养条件、亚种和株（isolate）有关。
        <br/>
      </p>
    </div>
  </div>
</template>

<script>
import { recordDetailInfo } from '../../../request/request';

  export default {
    mounted(){
      recordDetailInfo('技术服务-菌种鉴定');
    },
    data () {
      return {
        value2: 0,
        advantage: [
          {
            img: 'static/image/finance1.png',
            tit: '快速安装接入',
            con: '服务器对外部网络完全隔离，仅支持内部网络访问<br>服务器采用负载均衡设计，可实现自动转移错误，支持水平扩展',
          },
          {
            img: 'static/image/finance2.png',
            tit: '数据安全无忧',
            con: '支持大量特征数据的实时运算，响应速度快，性能优异',
          },
          {
            img: 'static/image/finance3.png',
            tit: '多维数据管理',
            con: '针对金融业务政策变化大的特点，支持模型、规则的灵活配置，更加贴合业务场景',
          }
        ]
      }
    }
  }
</script>

<style  lang="less">

.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
}
.custom-table th, .custom-table td {
  border: 1px solid black;
  padding: 0px;
  text-align: center;
}
.custom-table th {
  background-color: #2596dc;
  color: white;
}

  .finance-content{
    margin-left: -1px;
    .background{
      margin-bottom:64px;
      h4{
        margin: 32px 0 16px 0;
      }
      p{
        color: #7b8799;
      }
    }
    .function{
      h3{
        margin: 20px 0 40px 0;
        font-size: 22px;
      }
      .function-card{
        h4{
          font-size: 18px;
          margin-left: 10px;
        }
       ul{
         margin-top: 24px;
         li{
           color: #979797;
           line-height: 24px;
           list-style: disc;
           margin-left: 10px;
         }
       }
        .garden{
          display: inline-block;
          list-style: none;
          width: 40px;height: 40px;
          border-radius: 50%;
          background: #eff5fd;
          text-align: center;
          line-height: 40px;
          position: absolute;
          color: #409EFF;
          font-size: 20px;
          left: -20px;top: -20px;
        }
      }
      .el-card{
        overflow: inherit;
        min-height: 180px;
      }
      @media (min-width:1024px) and (max-width:1140px) {
        .el-card{
          min-height: 200px;
        }
      }
    }
    .advantage{
      h3{
        margin-bottom: 32px;
      }
      .cards{
        margin-bottom: 22px;
        padding: 15px 0 25px 0;
        background: #FBFCFD;
        span{
          margin-top: 11px;
          display: block;
        }
        p{
          margin: 40px 0 0 30px;
        }
      }
    }
    .access{
      h3{
        margin: 65px 0 40px 0;
        font-size: 22px;
      }
    }
    @media (max-width: 768px){
      .cards-div{
        display: block;
      }
      .cards-box{
        float: none;
        width: 80%;
        margin: 0 auto 30px;
      }
      .advantage{
        .cards p{
          margin: 20px 0 0 20px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/content/solution/finance.vue